import React, { useState, useEffect } from 'react';
import {
	Button,
	Col,
	Input,
	Row,
	Label,
	ModalBody,
	Form,
	TabPane,
	TabContent,
	Spinner,
	FormFeedback,
	FormGroup,
	CardBody,
	Card,
} from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

//redux 
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import OSelect from '../../../../Components/OElements/OSelect';
import { getEstablishmentList } from '../../../../helpers/establishment/backend_helper';
import { getProductiveCycleActive } from '../../../../slices/thunks';
import { getProvidersList, getProvidersOptionsList, getSitesList } from '../../../../helpers/data_providers/backend_helper';

const InformationRegisterSMAForm = ({ dataInformationRegisterSMA, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const selectorInformationRegisterSMA = createSelector(
		state => state.informationRegisterSMAProvider,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal, } = useSelector(selectorInformationRegisterSMA);

	const selectorEstablishments = createSelector(
		state => state.Establishments,
		establishment => ({
			productive_cycle: establishment.productiveCycleActiveDetail,
			isLoading: establishment.isLoading,
			isSuccess: establishment.isSuccess,
			isError: establishment.isError,
		})
	);
	const { productive_cycle } = useSelector(selectorEstablishments);


	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			establishment_id: '',
			provider_id: '',
			site_id: '',
			code_siep: '',
			code_sma: '',
			date_ini: '',
			date_end: '',
			site_id: '',
		},
		validationSchema: Yup.object({
			establishment_id: Yup.string().required('Campo requerido'),
			provider_id: Yup.string().required('Campo requerido'),
			site_id: Yup.string().required('Campo requerido'),
		}),
		validateOnChange: true,
		onSubmit: async values => {
			// const formData = {
			// 	...values,
			// 	stages: stageDates,
			// 	...(isEdit && { _id: dataInformationRegisterSMA._id }),
			// };

			// let cycle;
			// if (isEdit) {
			// 	cycle = await dispatch(addInformationRegisterSMA(formData));
			// } else {
			// 	cycle = await dispatch(addInformationRegisterSMA(formData));
			// }
		},
	});

	const [selectedEstablishment, setSelectedEstablishment] = useState(null); 


	const handleSelectedProvider = (optionSelected) => {
		console.log(optionSelected)
	};









	useEffect(() => {
		if (selectedEstablishment) {
			validation.setFieldValue('establishment_id', selectedEstablishment._id);
			validation.setFieldValue('code_siep', selectedEstablishment.code_siep);
			validation.setFieldValue('code_sma', selectedEstablishment.code_sma);
			dispatch(getProductiveCycleActive(selectedEstablishment._id));
		}
		else {
			validation.setFieldValue('establishment_id', '');
			validation.setFieldValue('code_siep', '');
			validation.setFieldValue('code_sma', '');
		}
	}, [selectedEstablishment]);


	useEffect(() => {
		if (productive_cycle) {
			validation.setFieldValue('date_ini', productive_cycle.date_ini);
			validation.setFieldValue('date_end', productive_cycle.date_end);
		}
		else {
			validation.setFieldValue('date_ini', '');
			validation.setFieldValue('date_end', '');
		}
	}, [productive_cycle]);





	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<TabContent activeTab={activeTab}>
					<TabPane tabId='1'>

						<Row>
							<Col lg={4}>
								<OSelect
									key={'establishment_id'}
									label='Establecimiento'
									id='establishment_id'
									name='establishment_id'
									value={validation.values.establishment_id || ''}
									onSelect={setSelectedEstablishment}
									requestApi={() => getEstablishmentList({})}
									validation={validation}
								/>
							</Col>
							<Col lg={4}>
								<OSelect
									key={'provider_id'}
									label='Proveedor de Sensores'
									id='provider_id'
									name='provider_id'
									value={validation.values.provider_id || ''}
									onSelect={handleSelectedProvider}
									requestApi={() => getProvidersList({})}
									validation={validation}
								/>
							</Col>

						</Row>
					</TabPane>
				</TabContent>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}}
						className='btn-danger btn-label'
					>
						<i className='icon-x label-icon'></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isAdding ||
							isUpdating
						}
					>
						{isAdding ||
							isUpdating ?
							(<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						{isEdit ? 'Editar' : 'Crear'} Catastro
					</button>
				</div>
			</div>
		</Form>
	);
};

export default InformationRegisterSMAForm;
